// import { useStore } from "effector-react"
import React from "react";
import { NavLink } from "react-router-dom";
import { SidebarGroupList } from "./DemSidebarGroupList";
import {
  pathDemandSubPay,
  pathDemandSubFree,
  pathDemandSubAppeals,
} from "../../../common/config/vars";
import "../styles/DemandSidebar.css";
import { AccessControl } from "../../../common/ui/AccessControl";
import { isIntfAccessDenied, keyIntfCategories, keyIntfDemandsFree, keyIntfDemandsPay } from "../../../common/disabledInterfaces";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";

interface IDemandSidebar {
  setCurrItem: React.Dispatch<React.SetStateAction<string>>;
}

export const DemandSidebar = ({ setCurrItem }: IDemandSidebar) => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const buttonClassName = `${openMenu
      ? "dem-sidebar-button dem-sidebar-button_active"
      : "dem-sidebar-button"
    }`;
  function openCloseMenu() {
    setOpenMenu(!openMenu);
  }
  function closeByRedirect(itemText: string) {
    setOpenMenu(false);
    setCurrItem(itemText);
  }
  const sidebarClassName = `${openMenu ? "dem-sidebar dem-sidebar-active" : "dem-sidebar"
    }`;

  return (
    <>
      <div className="dem-sidebar-button-container">
        <button className={buttonClassName} onClick={openCloseMenu}>
          <span></span>
        </button>
      </div>
      <div className={sidebarClassName}>
        <ul style={{ width: "100%" }}>
          <li>
            <div className="category">{getCustomUserAgent()===getCustomUserAgentASB()?"Мои заявки":"Мои заказы"}</div>
            <ul>
              <li>
                <NavLink
                  hidden={isIntfAccessDenied(keyIntfDemandsPay)}
                  exact
                  to={pathDemandSubPay}
                  className="category-item"
                  onClick={() => closeByRedirect("Платные заявки")}
                >
                  Платные заявки
                </NavLink>
              </li>
              <li>
                <NavLink
                hidden={isIntfAccessDenied(keyIntfDemandsFree)}
                  exact
                  to={pathDemandSubFree}
                  className="category-item"
                  onClick={() => closeByRedirect("Бесплатные заявки")}
                >
                  Бесплатные заявки
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={pathDemandSubAppeals}
                  className="category-item"
                  onClick={() => closeByRedirect("Обращения")}
                >
                  Обращения
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
        <AccessControl intf={keyIntfCategories} ok={<SidebarGroupList setCurrItem={setCurrItem} />}/>
        
      </div>
    </>
  );
};
